import { useEffect, useState } from "react";
import React from "react";
import { Link } from "react-router-dom";
import SiteLayout from "@/components/SiteLayout";
import useScrollReveal from "@/hooks/useScrollReveal";
import HeroBadge from "@/components/HeroBadge";
import { Heart, ShieldCheck, Sparkles, Users, Award, Stethoscope, Activity, Building2, ArrowRight, MapPin, Phone, Eye, Target } from "lucide-react";
import { TEAM } from "@/data/team";
import heroaboutImage1 from "@/assets/npc-about-hero-1.jpg";
import heroaboutImage2 from "@/assets/npc-about-hero-2.jpg";
import heroaboutImage3 from "@/assets/npc-about-hero-3.jpg";
import heroaboutImage4 from "@/assets/npc-about-hero-4.jpg";
import heroaboutImage5 from "@/assets/npc-about-hero-5.jpg";
import heroaboutImage6 from "@/assets/npc-about-hero-6.jpg";
import heroaboutImage7 from "@/assets/npc-about-hero-7.jpg";
import heroaboutImage8 from "@/assets/npc-about-hero-8.jpg";
import heroaboutImage9 from "@/assets/npc-about-hero-9.jpg";
import heroaboutImage10 from "@/assets/npc-about-hero-10.jpg";
import heroaboutImage11 from "@/assets/npc-about-hero-11.jpg";
import heroaboutImage12 from "@/assets/npc-about-hero-12.jpg";

const docAvatar = (d) =>
  `https://ui-avatars.com/api/?name=${encodeURIComponent(d.n.replace("Dr. ", ""))}&background=${d.color || "1E4F87"}&color=FFFFFF&bold=true&size=400&font-size=0.36`;

const TIMELINE = [
  ["2019", "Founded by a small team of clinicians and operators in Surat."],
  ["2021", "Crossed 25+ specialist doctors and 12+ departments."],
  ["2023", "Adajan New Building inaugurated — our flagship multi-specialty hub."],
  ["2025", "Nirmal Privilege Card launched exclusively for families of Adajan & west Surat."],
];

const HERO_SLIDES = [
  { src: heroaboutImage1, alt: "Nirmal Multi Speciality Hospital — Surat" },
  { src: heroaboutImage2, alt: "Modern hospital lobby" },
  { src: heroaboutImage3, alt: "Specialist doctor in consult" },
  { src: heroaboutImage4, alt: "Advanced diagnostic care" },
  { src: heroaboutImage5, alt: "Patient in recovery" },
  { src: heroaboutImage6, alt: "Modern ICU" },
  { src: heroaboutImage7, alt: "State-of-the-art operating room" },
  { src: heroaboutImage8, alt: "Patient-friendly waiting area" },
  { src: heroaboutImage9, alt: "Well-equipped pharmacy" },
  { src: heroaboutImage10, alt: "Modern laboratory" },
  { src: heroaboutImage11, alt: "Specialist consultation room" },
  { src: heroaboutImage12, alt: "Rehabilitation center" },
];

export default function About() {
  useScrollReveal();
  return (
    <SiteLayout>
      {/* HERO */}
      <section className="hero-grad relative overflow-hidden">
        <div className="absolute inset-0 dot-grid opacity-50 pointer-events-none" />
        <div className="mx-auto max-w-7xl px-6 lg:px-10 pt-16 pb-20 grid lg:grid-cols-12 gap-10 items-center relative">
          <div className="lg:col-span-7 reveal">
            <HeroBadge>About · <span className="text-[#A53A2A]">Nirmal Hospital, Adajan</span></HeroBadge>
            <h1 className="mt-5 font-display text-5xl lg:text-7xl font-bold text-[#0F2540] leading-[1.04]">
              Care par
              <br /><span className="bg-gradient-to-r from-[#A53A2A] via-[#C89B3C] to-[#A53A2A] bg-clip-text text-transparent">excellence</span> — every single day.
            </h1>
            <p className="mt-6 text-lg text-[#5C6B7A] leading-relaxed max-w-2xl">
              <strong className="text-[#0F2540]">Nirmal Super Speciality Hospital — Adajan</strong> is a multi-specialty health hub on Subhash Chandra Bose Marg (Beside Hari Om Petrol Pump), equipped with state-of-the-art infrastructure across specialties and super-specialties, supported by 24×7 services, advanced diagnostics, and a patient-friendly ambiance — exclusively built for the families of Adajan, L. P. Savani and west Surat.
            </p>
          </div>
          <div className="lg:col-span-5 relative">
  <HeroSlider />

  <div className="absolute -bottom-6 -left-6 lux-card rounded-2xl p-5 w-64 float z-10">
    <div className="flex items-center gap-2 text-sm font-semibold text-[#1E4F87]">
      <Award className="h-4 w-4 text-[#A53A2A]" />
      NABH-aligned
    </div>

    <p className="mt-1 text-xs text-[#5C6B7A]">
      Quality and safety protocols across all departments.
    </p>
  </div>
</div>
        </div>
      </section>

      {/* WHO WE SERVE / CARE PROMISE / SPECIALTIES — complementary to Vision/Mission below */}
      {/* <section className="mx-auto max-w-7xl px-6 lg:px-10 py-16 grid lg:grid-cols-3 gap-6">
        {[
          [Users, "Who we serve", "Families of Adajan, L. P. Savani, Pal, Rander, Palanpur Patia and the wider west Surat region — across every age and life stage."],
          [ShieldCheck, "Our care promise", "Care with compassion. Service with excellence. Decisions guided by clinical evidence — not commercial pressure."],
          [Stethoscope, "Our specialties", "Cardiology, Oncology, Neurology, Pediatrics, Orthopedics, ENT, Nephrology, Critical Care, Gynecology, Urology and more."],
        ].map(([Icon, t, d], i) => (
          <div key={t} className="reveal lux-card rounded-2xl p-8" style={{ animationDelay: `${i * 100}ms` }}>
            <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-[#1E4F87] to-[#0F2540] text-white grid place-items-center"><Icon className="h-6 w-6" /></div>
            <h3 className="mt-5 font-display text-xl font-bold text-[#0F2540]">{t}</h3>
            <p className="mt-2 text-[#5C6B7A]">{d}</p>
          </div>
        ))}
      </section> */}

      {/* JOURNEY */}
      {/* <section className="mx-auto max-w-7xl px-6 lg:px-10 py-12">
        <div className="reveal max-w-2xl">
          <span className="overline">Our journey</span>
          <h2 className="mt-3 font-display text-4xl sm:text-5xl font-bold text-[#0F2540]">Six years of growing, with Surat.</h2>
        </div>
        <div className="mt-12 grid md:grid-cols-4 gap-5 relative">
          <div className="absolute top-12 left-6 right-6 h-px bg-gradient-to-r from-[#1E4F87]/40 via-[#A53A2A]/40 to-[#C89B3C]/40 hidden md:block" />
          {TIMELINE.map(([y, t], i) => (
            <div key={y} className="reveal lux-card rounded-2xl p-6 relative" style={{ animationDelay: `${i * 100}ms` }}>
              <div className="font-display text-3xl font-bold text-[#A53A2A]">{y}</div>
              <p className="mt-2 text-sm text-[#0F2540] leading-relaxed">{t}</p>
            </div>
          ))}
        </div>
      </section> */}

      {/* VISION · MISSION · WE STRIVE TO — canonical hospital statements */}
      <section className="mx-auto max-w-7xl px-6 lg:px-10 py-16">
        <div className="reveal max-w-2xl">
          <span className="overline">Vision · Mission · Our Pursuit</span>
          <h2 className="mt-3 font-display text-4xl sm:text-5xl font-bold text-[#0F2540]">What we stand for.</h2>
          <p className="mt-3 text-[#5C6B7A] text-lg">The compass that guides every clinician, every conversation, every decision at Nirmal Super Speciality Hospital.</p>
        </div>

        <div className="mt-10 grid lg:grid-cols-2 gap-6">
          {/* Vision */}
          <div className="reveal lux-card rounded-2xl p-8 lg:p-10" data-testid="vision-card">
            <div className="flex items-center gap-3">
              <div className="h-11 w-11 rounded-xl bg-gradient-to-br from-[#1E4F87] to-[#0F2540] text-white grid place-items-center shadow-lg">
                <Eye className="h-5 w-5" />
              </div>
              <h3 className="font-display text-xl font-bold text-[#0F2540]">Vision</h3>
            </div>
            <p className="mt-5 font-display text-xl sm:text-2xl text-[#0F2540] leading-snug">
              To provide <span className="text-[#A53A2A]">advance healthcare services</span> with quality care on a foundation of <span className="text-[#1E4F87]">integrity</span> and <span className="text-[#1E4F87]">compassion</span>.
            </p>
          </div>

          {/* Mission */}
          <div className="reveal lux-card rounded-2xl p-8 lg:p-10" style={{ animationDelay: "120ms" }} data-testid="mission-card">
            <div className="flex items-center gap-3">
              <div className="h-11 w-11 rounded-xl bg-gradient-to-br from-[#A53A2A] to-[#7A2A1E] text-white grid place-items-center shadow-lg">
                <Target className="h-5 w-5" />
              </div>
              <h3 className="font-display text-xl font-bold text-[#0F2540]">Mission</h3>
            </div>
            <p className="mt-5 font-display text-xl sm:text-2xl text-[#0F2540] leading-snug">
              At Nirmal Hospital, our mission is to <span className="text-[#A53A2A]">deliver trusted, patient-centric healthcare services</span> with unwavering integrity and compassion.
            </p>
          </div>
        </div>

        {/* We Strive To */}
        <div className="mt-6 reveal lux-card rounded-2xl p-8 lg:p-10" style={{ animationDelay: "200ms" }} data-testid="strive-card">
          <div className="flex items-center gap-3">
            <div className="h-11 w-11 rounded-xl bg-gradient-to-br from-[#C89B3C] to-[#A0741F] text-white grid place-items-center shadow-lg">
              <Sparkles className="h-5 w-5" />
            </div>
            <h3 className="font-display text-xl font-bold text-[#0F2540]">We Strive To</h3>
          </div>
          <ol className="mt-6 grid md:grid-cols-3 gap-5">
            {[
              "Provide quality healthcare to the community.",
              "Establish a premier academic institute in healthcare.",
              "Foster a culture of continuous learning and innovation.",
            ].map((item, i) => (
              <li key={i} className="flex items-start gap-3 bg-[#F4F7FB] rounded-xl p-5 border border-[#E5E9F0]">
                <span className="h-7 w-7 flex-shrink-0 rounded-full bg-[#0F2540] text-white grid place-items-center font-display text-sm font-bold">{i + 1}</span>
                <span className="text-[#0F2540] leading-relaxed text-sm sm:text-base">{item}</span>
              </li>
            ))}
          </ol>
        </div>
      </section>

      {/* TEAM */}
      {/* <section className="mx-auto max-w-7xl px-6 lg:px-10 py-16">
        <div className="flex items-end justify-between flex-wrap gap-4 reveal">
          <div className="max-w-xl">
            <span className="overline">Specialists</span>
            <h2 className="mt-3 font-display text-4xl sm:text-5xl font-bold text-[#0F2540]">Doctors who support <span className="text-[#A53A2A]">and lead.</span></h2>
            <p className="mt-3 text-[#5C6B7A]">A glimpse of our 30+ consulting specialists across cardiology, neurology, oncology, paediatrics and more.</p>
          </div>
          <Link to="/contact" className="btn-ghost">Book consultation <ArrowRight className="h-4 w-4" /></Link>
        </div>
        <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-5">
          {TEAM.map((d, i) => (
            <div key={d.n} className="reveal lux-card rounded-2xl overflow-hidden group" style={{ animationDelay: `${i * 80}ms` }}>
              <div className="aspect-[4/5] bg-gradient-to-br from-[#EAF1FA] to-white relative overflow-hidden">
                <img src={d.image || docAvatar(d)} alt={d.n} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-black/30 to-transparent" />
              </div>
              <div className="p-5">
                <div className="font-display text-base font-semibold text-[#0F2540]">{d.n}</div>
                <div className="text-xs uppercase tracking-wider text-[#A53A2A] mt-1">{d.role || d.speciality || d.s}</div>
                {d.qualification ? (
                  <div className="mt-2 text-sm text-[#5C6B7A]">{d.qualification}</div>
                ) : null}
                {d.experience ? (
                  <div className="mt-1 text-sm text-[#5C6B7A] font-medium">{d.experience}</div>
                ) : null}
              </div>
            </div>
          ))}
        </div>
      </section> */}

      {/* LOCATION */}
      {/* <section className="mx-auto max-w-7xl px-6 lg:px-10 py-16">
        <div className="rounded-[2rem] mesh-dark p-10 lg:p-14 grid lg:grid-cols-12 gap-8 items-center relative overflow-hidden reveal">
          <div className="absolute inset-0 dot-grid opacity-15 pointer-events-none" />
          <div className="lg:col-span-7 relative">
            <span className="overline text-[#C89B3C]">Visit our New Building</span>
            <h3 className="mt-3 font-display text-3xl lg:text-5xl font-bold text-white leading-tight">Nirmal Hospital — Adajan, Surat.</h3>
            <p className="mt-4 text-white/80 text-lg flex items-start gap-2"><MapPin className="h-5 w-5 mt-1 text-[#C89B3C] flex-shrink-0" /> Nirmal Super Speciality Hospital, Subhash Chandra Bose Marg, Beside Hari Om Petrol Pump, Adajan, L. P. Savani, Surat — 395009, Gujarat, India</p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link to="/contact" className="bg-white text-[#0F2540] px-6 py-3 rounded-full font-semibold inline-flex items-center gap-2 hover:bg-[#C89B3C] transition">Plan your visit <ArrowRight className="h-4 w-4" /></Link>
              <a href="tel:+916357033301" className="border border-white/40 text-white px-6 py-3 rounded-full font-semibold inline-flex items-center gap-2 hover:bg-white/10 transition"><Phone className="h-4 w-4" /> +91-63570-33301</a>
            </div>
          </div>
          <div className="lg:col-span-5 grid grid-cols-2 gap-3 relative">
            {[[Users, "30+", "Doctors"], [Activity, "20+", "Departments"], [Sparkles, "1.2L+", "Patients served"], [Award, "24×7", "Emergency"]].map(([Icon, n, l]) => (
              <div key={l} className="rounded-2xl bg-white/10 backdrop-blur border border-white/20 p-5">
                <Icon className="h-5 w-5 text-[#C89B3C]" />
                <div className="mt-3 font-display text-3xl font-bold">{n}</div>
                <div className="text-xs uppercase tracking-wider text-white/70 mt-0.5">{l}</div>
              </div>
            ))}
          </div>
        </div>
      </section> */}
    </SiteLayout>
  );    
function HeroSlider() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActive((p) => (p + 1) % HERO_SLIDES.length);
    }, 4000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="relative rounded-[2rem] overflow-hidden ring-1 ring-[#E1E8F0] shadow-2xl tilt h-[460px]">
      {HERO_SLIDES.map((slide, i) => (
        <img
          key={i}
          src={slide.src}
          alt={slide.alt}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ${
            active === i ? "opacity-100" : "opacity-0"
          }`}
        />
      ))}

      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 flex gap-2 z-10">
        {HERO_SLIDES.map((_, i) => (
          <button
            key={i}
            onClick={() => setActive(i)}
            className={`h-2.5 rounded-full transition-all duration-300 ${
              active === i
                ? "w-8 bg-white"
                : "w-2.5 bg-white/50 hover:bg-white/80"
            }`}
          />
        ))}
      </div>

      <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent" />
    </div>
  );
}                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 }